import { render, staticRenderFns } from "./sku-list.vue?vue&type=template&id=468eb3a0&lang=pug"
import script from "./sku-list.vue?vue&type=script&lang=js"
export * from "./sku-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports